import { createDashboardRoute } from '@/utils/routing/Dashboard'

export default ({ route, store, redirect }) => {
  const currentRouteMeta = (route.meta.length > 0)
    ? route.meta.slice(-1)[0]
    : null

  const roles = (currentRouteMeta != null)
    ? currentRouteMeta.roles
    : null

  const hasRole = store.getters['admin/hasRole']

  if (roles != null && !hasRole(roles)) {
    return redirect(createDashboardRoute())
  }
}
